import { Injectable } from '@angular/core';
import { PartnersService as BossApiPartnersService } from 'src/app/modules/boss-api/generated/services';
import { AccountPartnerDC } from 'src/app/modules/boss-api/generated/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {

  private readonly authToken = null;

  constructor(
    public bossPartnersService: BossApiPartnersService
  ) { }

  getPartners(): Observable<AccountPartnerDC[]> {
    return this.bossPartnersService.PartnersGetAccountPartners(this.authToken);
  }

  getPartnerByCode(partnerCode): Observable<AccountPartnerDC> {
    const params = {
      partnerCode: partnerCode,
      Authorization: this.authToken
    };
    return this.bossPartnersService.PartnersGetSupportPartnerByCode(params);
  }

  getVarPartners() {
    return this.bossPartnersService.PartnersGetAccountVarPartners(null);
  }

  getPartnerLogo(partnerCode): Observable<Blob> {
    const params = {
      partnerCode: partnerCode,
      Authorization: this.authToken
    };
    return this.bossPartnersService.PartnersLogo(params);
  }

}
